import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initWeddingApplicationFunction() {  
    let courseSwiper;
    const mqSp = window.matchMedia(MEDIA_QUERIES.smartphone);

    const initSlider = () => {
        if (courseSwiper) return;

        courseSwiper = new Swiper(".js-pastWeddingSlider", {
            spaceBetween: 30,
            slidesPerView: 1,
            observer: true,
            resizeObserver: true,
            observeParents: true,
            pagination: {
                el: '.pastWeddingSlider__pagination',
                clickable: true, 
            },
        });
    };

    const destroySlider = () => {
        if (courseSwiper && typeof courseSwiper.destroy === "function") {
            courseSwiper.destroy(true, true);
            courseSwiper = null;
        }
    };

    const handleBreakpoint = (e) => {
        if (e.matches) {
            initSlider();
        } else {
            destroySlider();
        }
    };

    mqSp.addEventListener("change", handleBreakpoint);
    handleBreakpoint(mqSp);
}